export default __webpack_public_path__ + "static/logo-alicja-0bc1e3bd38929e952145505a60c9219b.svg";